[
  {
    "name": "Ilya<br>Kolomak",
    "role": "Team Lead<br>Scrum Master",
    "git": "https://github.com/ilya-kolomak",
    "img": "https://avatars.githubusercontent.com/u/99127402?v=4"
  },
  {
    "name": "Serhii<br>Artyshchuk",
    "role": "Developer",
    "git": "https://github.com/LachesisAsa",
    "img": "https://avatars.githubusercontent.com/u/104760743?v=4"
  },
  {
    "name": "Tanya<br>Kuchak",
    "role": "Developer",
    "git": "https://github.com/TanyaKuchak",
    "img": "https://avatars.githubusercontent.com/u/105127427?v=4"
  },
  {
    "name": "Alisa<br>Verbitska",
    "role": "Developer",
    "git": "https://github.com/VerbitskaAlisa",
    "img": "https://avatars.githubusercontent.com/u/104210874?v=4"
  },
  {
    "name": "Oleksii<br>Nedohybchenko",
    "role": "Developer",
    "git": "https://github.com/aleksnedo",
    "img": "https://avatars.githubusercontent.com/u/104201289?v=4"
  },
  {
    "name": "Nikita<br>Polozov",
    "role": "Developer",
    "git": "https://github.com/Npolozov",
    "img": "https://avatars.githubusercontent.com/u/103377917?v=4"
  },
  {
    "name": "Veronika<br>Terletska",
    "role": "Developer",
    "git": "https://github.com/VeronikaTerletska",
    "img": "https://avatars.githubusercontent.com/u/104487544?s=400&u=ee1ed9b353f046a781415b57f2d339fb54a9c546&v=4"
  },
  {
    "name": "Nikita<br>Zheldak",
    "role": "Developer",
    "git": "https://github.com/NickBayern",
    "img": "https://avatars.githubusercontent.com/u/97752779?v=4"
  },
  {
    "name": "Yuliia<br>Bakai",
    "role": "Developer",
    "git": "https://github.com/Yuliia-Bakai",
    "img": "https://avatars.githubusercontent.com/u/103931718?v=4"
  },
  {
    "name": "Roman<br>Stets",
    "role": "Developer",
    "git": "https://github.com/IndieHippie",
    "img": "https://avatars.githubusercontent.com/u/106179464?v=4"
  },
  {
    "name": "Michael<br>Trubitsyn",
    "role": "Developer",
    "git": "https://github.com/mitru0217",
    "img": "https://avatars.githubusercontent.com/u/100318106?v=4"
  }
]
